import service from '@/services/types/mensaje'

export const namespaced = true

export const state = () => ({
  list: []
})

export const mutations = {
  LIST: (state, objs) => (state.list = objs.filter(e => e.annotation === 'Aceptado' || e.annotation === 'Rechazado'))
}

export const actions = {
  list: ({ commit, state }, value) => (state.list?.length ? state.list : service.list(value).then(result => commit('LIST', result) || result))
}
